import "./ProductsServices.module.css";
import Header from "@/reusable_sections/Header";
import ProductsCommodities from "./sections/ProductsCommodities";
import Services from "./sections/Services";
import IndustriesServed from "./sections/IndustriesServed";
import Footer from "@/reusable_sections/Footer";
export default function ProductsServicesPage() {
  return <div>
      <Header />
      <ProductsCommodities />
      <Services />
      <IndustriesServed />
      <Footer />
    </div>;
}